import {Component, EventEmitter, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {OrganisationService} from "../../services/organisation/organisation.service";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-teams-remove-team',
  templateUrl: './teams-remove-team.component.pug',
  styleUrls: ['./teams-remove-team.component.scss'],
  standalone: false
})
export class TeamsRemoveTeamComponent {
  @Output() closeEvent = new EventEmitter<string>();

  // pug file label text
  heading = $localize`Remove team`;
  removeButtonText = $localize`Remove`;
  removeButtonDisable = true;

  // data variables
  turnOffLoader = false;
  teamName = '';
  teamId = 0;
  conditionTrue = 0;
  selectedRole = '';
  canDirectRemove = false;
  totalUsers = -1;
  usersDontBelongToAnyOtherTeam = -1;
  usersBelongToAnyOtherTeam = -1;
  label1 = $localize`All users (`+ this.totalUsers +`)`;
  label2 = $localize`Only users who don’t belong to any other team (${this.usersDontBelongToAnyOtherTeam}))`;
  doNotReassign = false;

  dropDownOptions = [
    {'key': 2, 'value': 'Team 2', disabled: false},
    {'key': 3, 'value': 'Team 3'},
    {'key': 4, 'value': 'Team 4'},
  ];
  dropDownLabel = $localize`Select a team`;
  reassignTeam = 0;

  dropDownOptionSelected(option: any) {
    this.reassignTeam = option['key'];
    this.doNotReassign = option['key'] == 0;
    if(this.selectedRole !== ''){
      this.removeButtonDisable = false;
    }
  }

  constructor(
    public modalRef: BsModalRef,
    private organisationService: OrganisationService,
    private permissions: PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.organisationService.removeTeamValidate({id: this.teamId, name: this.teamName}).subscribe({
          next: response => {
            this.removeTeamConditions(response);
            this.turnOffLoader = true;
          },
          error: response => {
            this.turnOffLoader = true;
          },    // errorHandler
          complete: () => {
          }, // completeHandler
        });

  }

  removeTeamConditions(response: any){
    this.canDirectRemove = response['can_direct_remove'];
    if(!this.canDirectRemove){
      this.totalUsers = response['no_of_users_in_team'];
      this.usersBelongToAnyOtherTeam = response['no_of_users_other_assigned_team'];
      this.usersDontBelongToAnyOtherTeam = response['no_of_users_unassigned_other_team'];
      this.label1 = $localize`All users (${this.totalUsers})`;
      this.label2 = $localize`Only users who don’t belong to any other team (${this.usersDontBelongToAnyOtherTeam})`;

      this.dropDownOptions = response['teams'].map(function(obj) {
        return {
          key: obj.id,
          value: obj.name
        };
      }).filter(option => option.key !== this.teamId);

    }

    // 1st Condition Scenarios:
    //    when no users are assigned to this team
    //    when all users belong to all teams (and reassignment is obsolete)
    if(this.canDirectRemove){
      this.conditionTrue = 1;
      this.removeButtonDisable = false;
    }
    //  2nd Condition Scenarios:
    //    Scenario when “Only users who don’t belong to any other team” = 0
    //    “All users” is preselected
    //    Remove button is disabled, until a reassignment option has been selected. This includes selecting ‘Do not reassign’, or any team.
    //    Default team should be listed
    else if(this.usersDontBelongToAnyOtherTeam === 0){
      this.conditionTrue = 2;
      this.selectedRole = 'all';
      this.dropDownLabel = $localize`Select an option`;
      this.dropDownOptions.splice(0, 0, {'key': 0, 'value': $localize`Do not reassign`});
      this.dropDownOptions.splice(1, 0, {'key': 1, 'value': $localize`Teams`, disabled: true});
    }
    //  3rd Condition Scenarios:
    //    Scenario when “Only users who don’t belong to any other team” > 0
    //    Neither option is preselected
    //    Default team should be listed
    else if(0 < this.usersDontBelongToAnyOtherTeam && this.usersDontBelongToAnyOtherTeam < this.totalUsers){
      this.conditionTrue = 3;
      this.dropDownOptions.splice(0, 0, {'key': 0, 'value': $localize`Teams`, disabled: true});
    }
    //  4th Condition Scenarios:
    //    Scenario when “Only users who don’t belong to any other team” = all users
    //    “Required user” option is preselected
    else if(this.usersDontBelongToAnyOtherTeam === this.totalUsers){
      this.conditionTrue = 4;
      this.selectedRole = 'unassigned'
      this.dropDownOptions.splice(0, 0, {'key': 0, 'value': $localize`Teams`, disabled: true});
    }
  }

  removeButtonClicked(){

    this.turnOffLoader = false;

    let removeTeamData = {
      id:this.teamId,
      reassignType: this.selectedRole,
      reassignTeam: this.reassignTeam,
      doNotReassign: this.doNotReassign
    }
    this.organisationService.deleteTeam(removeTeamData).subscribe({
          next: response => {
            this.turnOffLoader = true;
            this.closeEvent.emit('team-removed');
            this.modalRef?.hide();
          },
          error: response => {
            this.turnOffLoader = true;
          },    // errorHandler
          complete: () => {
          }, // completeHandler
        });

  }

  textValueChanged(event: any) {
  }

  logEvent(event: any): void{
    this.selectedRole = event;
    if (this.reassignTeam || this.doNotReassign) {
      this.removeButtonDisable = false;
    }
  }

}
